import React from 'react';
import { Modal, Stack } from 'react-bootstrap';
import styled from '@emotion/styled';
import SVButton from 'components/elements/SVButton';

const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0;
  border-bottom: 1px solid #e9ecef;
  
  &:last-child {
    border-bottom: none;
  }
`;

const InfoLabel = styled.span`
  font-weight: 600;
  color: #495057;
`;

const InfoValue = styled.span`
  color: #212529;
`;

interface VersionInfoModalProps {
  show: boolean;
  onHide: () => void;
  versions: {
    prqVersion?: number | null;
    meetingsAndRoundsVersion?: number | null;
    keyFindingsVersion?: number | null;
  };
}

const VersionInfoModal: React.FC<VersionInfoModalProps> = ({
  show,
  onHide,
  versions,
}) => {
  const versionItems = [
    { label: 'PRQ', value: versions.prqVersion },
    { label: 'Meetings & Rounds', value: versions.meetingsAndRoundsVersion },
    { label: 'Key Findings', value: versions.keyFindingsVersion },
  ];

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Version Information</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Stack gap={0}>
          {versionItems.map(({ label, value }) => (
            <InfoRow key={label}>
              <InfoLabel>
                {label}
                :
              </InfoLabel>
              <InfoValue>{value ? `Version ${value}` : 'Not submitted'}</InfoValue>
            </InfoRow>
          ))}
        </Stack>
      </Modal.Body>
      <Modal.Footer>
        <SVButton variant="secondary" onClick={onHide}>
          Close
        </SVButton>
      </Modal.Footer>
    </Modal>
  );
};

export default VersionInfoModal;
